export default __webpack_public_path__ + "static/media/14473_Atrium_E1_Insel4_1_roteTafel_1000x2430mm_RZ.8dbf2a5a.pdf";